import { useContext } from 'react';
import IntercomContext from '@/contexts/intercom';

const useIntercom = () => {
  const value = useContext(IntercomContext);

  return value;
};

export default useIntercom;